import { render } from "./KanaList.vue?vue&type=template&id=9806a1a0&scoped=true&ts=true"
import script from "./KanaList.vue?vue&type=script&lang=ts"
export * from "./KanaList.vue?vue&type=script&lang=ts"

import "./KanaList.vue?vue&type=style&index=0&id=9806a1a0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9806a1a0"]])

export default __exports__